/**
 * Chip compacto "Evolução" — paleta info/secondary, distinta do badge de PA.
 */
import { Chip, Tooltip } from "@mui/material";
import { Timeline } from "@mui/icons-material";

interface EvolutionBadgeProps {
  /** Label curto "EV" para espaços estreitos. */
  compact?: boolean;
}

export function EvolutionBadge({ compact = false }: EvolutionBadgeProps) {
  return (
    <Tooltip title="Atendimento de evolução do paciente">
      <Chip
        variant="outlined"
        icon={<Timeline sx={{ fontSize: 14 }} />}
        label={compact ? "EV" : "Evolução"}
        sx={{
          height: 20,
          bgcolor: "secondary100.main",
          color: "secondary700.main",
          borderColor: "secondary.main",
          "& .MuiChip-icon": { ml: 0.5, color: "secondary700.main" },
          "& .MuiChip-label": { px: 0.75, fontSize: 11 },
        }}
      />
    </Tooltip>
  );
}
